import React from "react";
import { Skeleton } from "@material-ui/lab";
const ContentLoading = () => {
    return (React.createElement("div", null,
        React.createElement(Skeleton, { width: "90%", animation: "wave" }),
        React.createElement(Skeleton, { width: "80%", animation: "wave" }),
        React.createElement(Skeleton, { width: "75%", animation: "wave" })));
};
export default ContentLoading;
//# sourceMappingURL=SkeletonLoading.js.map